import { render, staticRenderFns } from "./NbCheckbox.vue?vue&type=template&id=b8cefb7a&scoped=true&"
import script from "./NbCheckbox.vue?vue&type=script&lang=js&"
export * from "./NbCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NbCheckbox.vue?vue&type=style&index=0&id=b8cefb7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cefb7a",
  null
  
)

export default component.exports